export const safeDollarToCents = (
  input: string | number | undefined
): number | undefined => {
  const amount = Number(input);
  if (isNaN(amount)) return undefined;
  else return amount * 100;
};

export const safeCentsToDollar = (
  input: string | number | undefined
): number | undefined => {
  const amount = Number(input);
  if (isNaN(amount)) return undefined;
  else return amount / 100;
};

export const formatedAmountToNumber = (
  formatedAmount: string
): number | undefined => {
  if (formatedAmount.trim() === '') return undefined;
  const cleanedAmount = Number(formatedAmount.replace(/[$,]/g, ''));
  if (isNaN(cleanedAmount)) return undefined;
  return cleanedAmount;
};

export const formatDollarAmount = (input: string | number): string => {
  const result = (+input).toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return result;
};

export function formatCentsAmount(input: string | number): string {
  const result = (+input / 100).toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  return result;
}

export function enforce2Decimals(input: number): number {
  return (input * 100) / 100;
}
